/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IModelViewerViewProps } from './model-viewer';

export default (props: IModelViewerViewProps) => {
    const isMobileClassName = props.isMobile ? `${props.baseClassName}__image-wrapper--mobile` : '';
    return (
        <div className='row'>
            {props.heading}
            <div className={`${props.baseClassName}__image-wrapper ${isMobileClassName}`}>{props.hotspotImage}</div>
            {props.partsList}
        </div>
    );
};
